import { ImportData, InternalColumns } from 'features/importerv2/importer-types'
import {
  setCustomCompanyCategoryByHash,
  setReadyByRowId,
} from 'features/importerv2/importDataTransforms'

export interface OtherType {
  /** The parent category ID for the "Other" company type. */
  category_id: number
  /** The subcategory ID (value) for the "Other" company type. */
  value: number
}

/**
 * Mark all rows in `data` as custom-Other with the given category/subcategory,
 * then set READY=true for included rows and READY=false for excluded rows.
 *
 * @param data - The current ImportData.
 * @param excludedRowIds - Set of row IDs to mark NOT ready (user explicitly excluded them).
 * @param other - The "Other" category/subcategory IDs.
 */
export function markRowsCustomOther(
  data: ImportData,
  excludedRowIds: Set<string>,
  other: OtherType
): ImportData {
  const allHashes = data.rows.map((r) => r[InternalColumns.COMPANY_HASH])

  // Apply custom-Other category to every row (also sets IS_CUSTOM_COMPANY=true).
  let next = setCustomCompanyCategoryByHash(
    data,
    allHashes,
    other.category_id,
    other.value
  )

  const includedIds = next.rows
    .map((r) => String(r[InternalColumns.ROW_ID]))
    .filter((id) => !excludedRowIds.has(id))

  const excludedIds = next.rows
    .map((r) => String(r[InternalColumns.ROW_ID]))
    .filter((id) => excludedRowIds.has(id))

  next = setReadyByRowId(next, includedIds, true)
  next = setReadyByRowId(next, excludedIds, false)

  return next
}
